"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "barete": {
    "0d4f8dcd": [{
      "hkey": "1eae9db1",
      "slug": "san-sabino-basanello",
      "name": "San Sabino-Basanello",
      "primary": true,
      "skipSearch": false
    }],
    "basanello": [{
      "hkey": "1eae9db1",
      "slug": "san-sabino-basanello",
      "name": "San Sabino-Basanello",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "barete"
    }],
    "c6b64112": [{
      "hkey": "1eae9db1",
      "slug": "san-sabino-basanello",
      "name": "San Sabino-Basanello",
      "primary": true,
      "skipSearch": false
    }],
    "san-sabino": [{
      "hkey": "1eae9db1",
      "slug": "san-sabino-basanello",
      "name": "San Sabino-Basanello",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "a9732f77": [{
      "hkey": "1514fb93",
      "slug": "barete",
      "name": "Barete",
      "primary": true,
      "skipSearch": false
    }],
    "tarignano": [{
      "hkey": "1514fb93",
      "slug": "barete",
      "name": "Barete",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }]
  }
};
exports["default"] = _default;